import React, {Component} from 'react';
import PropTypes from 'prop-types';

class CubePlaceholderIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="48px"
          height="55px"
          viewBox="0 0 48 55"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          style={this.props.style}
        >
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="item" transform="translate(-140.000000, -112.000000)" fill="#c8c8c8">
              <g id="banner-mask">
                <path
                  d="M163.5079,112.129375 C163.8133,111.956875 164.1867,111.956875 164.4921,112.129375 L187.4921,125.129375 C187.8059,125.306775 188,125.639475 188,125.999975 L188,152.999975 C188,153.360475 187.8059,153.693175 187.4921,153.870575 L164.4921,166.870575 C164.1842,167.044575 163.8073,167.042975 163.5008,166.866475 L140.5008,153.616475 C140.191,153.437975 140,153.107575 140,152.749975 L140,125.999975 C140,125.639475 140.1941,125.306775 140.5079,125.129375 L163.5079,112.129375 Z M142,127.730175 L152.6696,133.876775 C151.888,135.504075 151.4497,137.325875 151.4497,139.249975 C151.4497,141.173675 151.8849,142.997975 152.6626,144.627675 L142,150.988975 L142,127.730175 Z M142.9771,152.734875 L163,164.269775 L163,151.714475 C159.1298,151.423675 155.752,149.370275 153.666,146.357875 L142.9771,152.734875 Z M165,151.706475 L165,164.286075 L185.0272,152.966375 L174.2274,146.366475 C172.159,149.348075 168.8244,151.388275 165,151.706475 Z M175.2324,144.636775 L186,151.216875 L186,127.730175 L175.2659,133.913875 C176.0257,135.532675 176.4497,137.341775 176.4497,139.249975 C176.4497,141.177275 176.0128,143.004675 175.2324,144.636775 Z M173.5256,134.916475 C174.1195,136.237175 174.4497,137.704275 174.4497,139.249975 C174.4497,141.164475 173.9382,142.956575 173.0451,144.500175 C171.3937,147.354175 168.4407,149.356475 165,149.698075 L165,139.827975 L173.5256,134.916475 Z M174.2739,132.177275 L184.9823,126.008275 L165,114.713875 L165,126.789375 C168.8622,127.095275 172.2122,129.158275 174.2739,132.177275 Z M163,126.789375 L163,114.713875 L143.0176,126.008275 L153.6773,132.149075 C155.7693,129.143475 159.148,127.094175 163,126.789375 Z M155.4182,133.152075 C157.3361,130.488175 160.4725,128.749975 164,128.749975 C167.5346,128.749975 170.646,130.497775 172.5349,133.179075 L164,138.095875 L155.4182,133.152075 Z M154.4091,134.878875 C153.7935,136.210175 153.4497,137.690675 153.4497,139.249975 C153.4497,141.164475 153.9612,142.956575 154.8543,144.500175 C156.5217,147.381975 159.5163,149.395375 163,149.707575 L163,139.827975 L154.4091,134.878875 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

CubePlaceholderIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

export default CubePlaceholderIcon;
